/* @flow */
/**
 * Created by Ondra on 14.10.2016.
 */
import React from 'react';
import {connect} from 'react-redux';
import CloseButton from '../buttons/CloseButton';

class Numerical extends React.Component {

    state: State = {
        value: ''
    };

    static propTypes = {
        defaultValue: React.PropTypes.oneOfType([
            React.PropTypes.string,
            React.PropTypes.number
        ]).isRequired,
        nonDecimal: React.PropTypes.bool,
        onSubmit: React.PropTypes.func.isRequired,
        onClose: React.PropTypes.func.isRequired,
        label: React.PropTypes.string.isRequired
    };

    constructor(props) {
        super(props);

        this.addToTheEnd = this.addToTheEnd.bind(this);
        this.removeFromTheEnd = this.removeFromTheEnd.bind(this);
        this.closeKeyboard = this.closeKeyboard.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.isValid = this.isValid.bind(this);
    }

    onSubmit() {
        if (this.isValid()) {
            const {onSubmit} = this.props;
            const {value} = this.state;
            let val = value.replace(',', '.');
            onSubmit(Number(val));
        }
    }

    closeKeyboard() {
        const {onClose} = this.props;
        this.setState({value: ''});
        onClose();
    }

    addToTheEnd(x) {
        const {value} = this.state;
        if (value.length > 10) {
            return;
        }

        if (value.length === 0 && x === ',') {
            this.setState({value: '0,'});
        } else if (value.length === 0 && x === '00') {
            this.setState({value: '0'});
        } else if (value === '0' && x === '00') {
            this.setState({value: '0'});
        } else if (value === '0' && x !== ',') {
            this.setState({value: x});
        } else if (value.indexOf(',') > -1 && x === ',') {
            let val = value.replace(',', '');
            if (val.length > 1 && val.charAt(0) === '0') {
                val = val.substring(1);
            }
            this.setState({value: val + x});
        } else {
            this.setState({value: value + x});
        }

    }

    removeFromTheEnd() {
        const {value} = this.state;
        if (value.length > 0) {
            this.setState({value: value.slice(0, -1)});
        }
    }

    componentWillMount() {
        const {defaultValue} = this.props;
        let value;
        if (isNaN(defaultValue)) {
            value = '';
        } else {
            value = `${defaultValue}`;
        }
        this.setState({value: value.replace('.', ',')});
    }

    isValid() {
        const {value} = this.state;
        return value.length !== 0;

    }

    render() {
        const {value} = this.state;
        const {nonDecimal, label} = this.props;

        return (
            <div className="keyboardPanel">
                <div className="keyboardPanel-panel">
                    <div className="keyboardPanel-row">
                        <span className="keyboardPanel-label">{label}</span>
                        <input className="keyboardPanel-input" value={value} readOnly/>
                    </div>
                </div>
                <div className="keyboardPanel-keyboard">
                    <div className="keyboard-num keyboardNum">
                        <div className="keyboardNum-keys">
                            {['7', '8', '9', '4', '5', '6', '1', '2', '3', '00', '0', ','].map((x, i) =>
                              <div key={`numerical-key-${i}`} className="keyboardNum-key">
                                <div
                                     className={`boxBtn text-l color-white ${!!nonDecimal && x === ',' ? 'disabled' : ''}`}
                                     onClick={() => this.addToTheEnd(x)}>
                                    <div className="boxBtn-inner">
                                        <span>{x}</span>
                                    </div>
                                </div>
                              </div>
                            )}
                        </div>
                        <div className="keyboardNum-controls">
                            <div className="keyboardNum-controls-key">
                            <div className="boxBtn color-red" onClick={() => this.closeKeyboard()}>
                                <CloseButton className="view-white"/>
                            </div>
                            </div>
                          <div className="keyboardNum-controls-key">
                            <div className="boxBtn color-white" onClick={() => this.removeFromTheEnd()}>
                                <div className="boxBtn-inner">
                                  <svg className={`shape shape-backspace`}>
                                    <use xlinkHref={`#shape-backspace`}></use>
                                  </svg>
                                </div>
                            </div>
                          </div>
                          <div className="keyboardNum-controls-key view-big">
                            <div className={`boxBtn text-white color-greenLight ${this.isValid() ? '' : 'disabled'}`}
                                 onClick={() => this.onSubmit()}>
                                <div className="boxBtn-inner">
                                    <svg className={`shape shape-enter`}>
                                      <use xlinkHref={`#shape-enter`}></use>
                                    </svg>
                                </div>
                            </div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(state => ({}))(Numerical);



// WEBPACK FOOTER //
// ./src/browser/components/keyboard/Numerical.js